module.exports = __webpack_public_path__ + "img/check_white.6c9b7844.svg";